/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedDocRejectRequest } from '../types/PatchedDocReject';
import type { DocRejectResponse } from '../types/DocReject';

export type BrnoDocsRejectPartialUpdateRequest = PatchedDocRejectRequest;
export type BrnoDocsRejectPartialUpdateResponse = DocRejectResponse;

export type BrnoDocsRejectPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/brno_docs/{id}/reject/
 *
 * ```yaml
 * operationId: brno_docs_reject_partial_update
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - brno_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocReject'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocReject'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocReject'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DocReject'
 *     description: ''
 * ```
 */
export const brnoDocsRejectPartialUpdateOperation = ({
  id,
  ...rest
}: BrnoDocsRejectPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/brno_docs/${id}/reject/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/brno_docs/{id}/reject/' };
  };

/**
 * PATCH /dmx-server/brno_docs/{id}/reject/
 *
 * ```yaml
 * operationId: brno_docs_reject_partial_update
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - brno_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocReject'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocReject'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocReject'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DocReject'
 *     description: ''
 * ```
 */
export const brnoDocsRejectPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: BrnoDocsRejectPartialUpdateQuery;
  request: PatchedDocRejectRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<DocRejectResponse>> => {
  const operation = brnoDocsRejectPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
